import { styled } from '@material-ui/core';
import themes from 'styles/themes';
import TextField from '@mui/material/TextField';

const styles = {
    input: {
        borderBottom: `1px solid ${themes.palette.grey['300']} !important`,
        color: themes.palette.primary.main,
        opacity: 1,
        borderRadius: '0 !important',
        textOverflow: 'ellipsis',
        fontSize: 14,
        fontWeight: 400,
        fontFamily: 'PoppinsRegular',
        width: '100%',
        minWidth: 280,
    },
    inputPlaceholder: {
        color: '#1A1A1A !important',
        opacity: 0.5,
        fontFamily: 'PoppinsRegular',
    },
};
export const StandardDatePickerFieldStyle = styled(TextField)({
    marginTop: '12px',
    '& input': styles.input,
    '& textarea': {
        ...styles.input,
        paddingBottom: 11,
        lineHeight: '16px',
    },
    '&::placeholder': styles.inputPlaceholder,
    '& input:hover, & input:not(:hover)': {
        borderBottom: `1px solid ${themes.palette.grey['300']} !important`,
    },
    '& [class*="MuiInputBase-root"]': {
        fontFamily: 'PoppinsRegular',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '24px',
        color: themes.palette.primary.main,
        borderBottom: `1px solid ${themes.palette.grey['300']} !important`,
    },
    '& [class*="MuiInputBase-multiline"]': {
        padding: '7px 0 0',
    },
    '& [class*="MuiFormHelperText-root"]': {
        color: 'red !important',
        fontFamily: 'PoppinsRegular',
        padding: 0,
        margin: '4px 0 0 0',
        fontSize: 12,
    },
    '& [class*="MuiInputBase-root"].Mui-focused': {
        borderBottom: `1px solid ${themes.palette.grey['300']} !important`,
    },
    '& [class*="MuiInputBase-root"].Mui-disabled:before': {
        borderBottom: `1px solid ${themes.palette.grey['300']} !important`,
    },
    '& [class*="MuiInputLabel-root"].Mui-focused': {
        opacity: 1,
        fontSize: 14,
    },
    '& [class*="MuiInput-underline"].Mui-focused': {
        borderBottom: `1px solid ${themes.palette.grey['300']} !important`,
    },
    '& [class*="MuiInput-underline"]:not(.Mui-disabled):before': {
        borderBottom: `1px solid ${themes.palette.grey['300']} !important`,
    },
    '& [class*="MuiInput-underline"]:not(.Mui-disabled):after': {
        borderBottom: `1px solid ${themes.palette.grey['300']} !important`,
    },
    '& [class*="MuiInputBase-input"]:not(.Mui-focused)': {
        borderBottom: `1px solid ${themes.palette.grey['300']} !important`,
    },
    '& label[class*="MuiInputLabel-root"]': {
        fontFamily: 'PoppinsRegular',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '14px',
        lineHeight: '24px',
        color: themes.palette.primary.main,
        opacity: 0.5,
        top: '-6px !important',
    },
    '& label[class*="MuiInputLabel-shrink"]': {
        opacity: '1 !important',
        transform: 'translate(0, 1.5px) scale(0.9)',
    },
});
